import React, { Fragment, useState } from 'react';
import { Button, Form, Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../../../../styles/botao.scss';

const FormBusca = (props) => {
    const [processo, setProcesso] = useState("");
    const [secretaria, setSecretaria] = useState("");

    // A cada mudança → aplicar filtro local
    const handleProcessoChange = (e) => {
        const value = e.target.value;
        setProcesso(value);
        props.filtrarLocalmente(value, secretaria);
    };

    const handleSecretariaChange = (e) => {
        const value = e.target.value;
        setSecretaria(value);
        props.filtrarLocalmente(processo, value);
    };

    const limpar = () => {
        setProcesso("");
        setSecretaria("");
        props.fetchSolicitacoes(); // restaura lista original
    };

    return (
        <Fragment>
            <Container className="da-espaco">

                <Row xs={1} lg={4}>

                    <Col xs={12} lg={4}>
                        <Form.Label>Processo</Form.Label>
                        <Form.Control
                            type="text"
                            value={processo}
                            onChange={handleProcessoChange}
                        />
                    </Col>
                    <Col xs={12} lg={4}>
                        <Form.Group controlId="selectSecretaria">
                            <Form.Label>Secretaria</Form.Label>
                            <Form.Select required value={secretaria} onChange={handleSecretariaChange}>
                                <option value="">TODAS</option>
                                <option value="Secretaria Municipal de Segurança Pública, Administração e Mobilidade Urbana">Segurança Pública, Administração e Mobilidade Urbana</option>
                                <option value="Secretaria Municipal de Agricultura, Pecuária, Abastecimento e Aquicultura">Agricultura, Pecuária, Abastecimento e Aquicultura</option>
                                <option value="Secretaria Municipal de Educação">Educação</option>
                                <option value="Secretaria Municipal de Esporte, Lazer, Turismo e Cultura">Esporte, Lazer, Turismo e Cultura</option>
                                <option value="Secretaria Municipal de Fazenda, Planejamento, Orçamento, Indústria e Comércio">Fazenda, Planejamento, Orçamento, Indústria e Comércio</option>
                                <option value="Secretaria Municipal de Gabinete e Comunicação">Gabinete e Comunicação</option>
                                <option value="Secretaria Municipal de Controle Interno">Controle Interno</option>
                                <option value="Secretaria Municipal de Governo e Gestão">Governo e Gestão</option>
                                <option value="Secretaria Municipal de Meio Ambiente, Urbanismo e Defesa Civil">Meio Ambiente, Urbanismo e Defesa Civil</option>
                                <option value="Secretaria Municipal de Obras e Serviços Públicos">Obras e Serviços Públicos</option>
                                <option value="Secretaria Municipal de Saúde e Prevenção à Dependência Química">Saúde e Prevenção à Dependência Química</option>
                                <option value="Secretaria Municipal de Desenvolvimento Social e Direitos Humanos">Desenvolvimento Social e Direitos Humanos</option>
                                <option value="Secretaria Municipal de Trabalho, Envelhecimento Saudável e da Juventude">Trabalho, Envelhecimento Saudável e da Juventude</option>
                                <option value="Departamento de Patrimônio">Patrimônio</option>
                                <option value="Departamento de Turismo">Turismo</option>
                                <option value="Departamento de Cultura">Cultura</option>
                                <option value="Junta Militar de Macuco">Junta Militar de Macuco</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={6} lg={2}>
                        <Button
                            type="button"
                            variant="danger"
                            className="alinha-botao"
                            onClick={limpar}
                        >
                            Limpar Busca
                        </Button>
                    </Col>
                    <Col xs={6} lg={2}>
                        <Link to={'/ti/solicitacao'}>
                            <Button variant="danger" className="alinha-botao" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default FormBusca;